"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var Popover =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Popover, _React$Component);

  function Popover(props) {
    var _this;

    _classCallCheck(this, Popover);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Popover).call(this, props));
    _this.popover = _react.default.createRef();
    _this.state = {
      display: 'none',
      top: 0,
      left: 0
    };
    return _this;
  }

  _createClass(Popover, [{
    key: "render",
    value: function render() {
      var styles = {
        display: this.state.display,
        top: this.state.top,
        left: this.state.left
      };
      return _react.default.createElement("div", {
        className: this.classes(),
        style: styles,
        ref: this.popover
      }, _react.default.createElement("div", {
        className: "arrow"
      }), this.titleRender(), this.contentRender());
    }
  }, {
    key: "classes",
    value: function classes() {
      return "popover popover-".concat(this.props.context, " ").concat(this.props.position, " fade in");
    }
  }, {
    key: "titleRender",
    value: function titleRender() {
      if (!this.props.title) {
        return null;
      }

      return _react.default.createElement("div", {
        className: "popover-title"
      }, this.props.title);
    }
  }, {
    key: "contentRender",
    value: function contentRender() {
      if (_react.default.Children.count(this.props.children) === 0) {
        return null;
      }

      return _react.default.createElement("div", {
        className: "popover-content"
      }, this.props.children);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (!this.props.attachedTo.current) {
        return;
      }

      this.eventFunction = function () {
        _this2.togglePopoverDisplay();
      };

      this.props.attachedTo.current.addEventListener(this.props.event, this.eventFunction);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.attachedTo.current) {
        this.props.attachedTo.current.removeEventListener(this.props.event, this.eventFunction);
      }
    }
  }, {
    key: "positionPopover",
    value: function positionPopover() {
      var refSquare = this.props.attachedTo.current.getBoundingClientRect();
      var thisSquare = this.popover.current.getBoundingClientRect();
      var x = this.props.attachedTo.current.offsetLeft;
      var y = this.props.attachedTo.current.offsetTop; // all of this math uses the top left point of the ref element to figure
      // out the position of the top left point of the popover

      switch (this.props.position) {
        case 'left':
          // go left the new width
          x = x - thisSquare.width; // go down half the ref element height

          y = y + refSquare.height / 2; // go up half this element height

          y = y - thisSquare.height / 2;
          break;

        case 'right':
          // go right the width of the ref element
          x = x + refSquare.width; // go down half the ref element height

          y = y + refSquare.height / 2; // go up half the new element height;

          y = y - thisSquare.height / 2;
          break;

        case 'bottom':
          // go down the height of the ref element;
          y = y + refSquare.height; // go right half the ref element;

          x = x + refSquare.width / 2; // go left half the new element;

          x = x - thisSquare.width / 2;
          break;

        case 'top':
        default:
          // go halfway over the ref element
          x = x + refSquare.width / 2; //go left half this element.

          x = x - thisSquare.width / 2; // go up this element in height

          y = y - thisSquare.height;
          break;
      }

      this.setState({
        left: x.toString() + 'px',
        top: y.toString() + 'px'
      });
    }
  }, {
    key: "togglePopoverDisplay",
    value: function togglePopoverDisplay() {
      if (this.state.display === 'none') {
        this.setState({
          display: 'block'
        }, this.positionPopover);
      } else {
        this.setState({
          display: 'none'
        });
      }
    }
  }]);

  return Popover;
}(_react.default.Component);

Popover.contexts = {
  default: 'default',
  primary: 'primary',
  warning: 'warning',
  danger: 'danger'
};
Popover.defaultProps = {
  context: Popover.contexts.default,
  event: 'click',
  position: 'top'
};
Popover.propTypes = {
  context: _propTypes.default.oneOf(Object.values(Popover.contexts)),
  position: _propTypes.default.oneOf(['top', 'left', 'right', 'bottom'])
};
var _default = Popover;
exports.default = _default;